//original js
//リロード時のハッシュを制御（特に#search-productでソート、リロードした時のバグに対応）


document.addEventListener('DOMContentLoaded', () => {
  // 現在のハッシュを取得
  const currentHash = window.location.hash;

  // 初期ロード時: #search-product 以外のハッシュが存在する場合はそのまま保持
  if (currentHash && currentHash !== '#search-product') {
    return;
  }

  // 初期ロード時: ハッシュがない場合は #search-product を追加
  if (!currentHash) {
    window.location.hash = '#search-product';
  }

  // MutationObserverを使ってソート後のURL変更を監視
  const observer = new MutationObserver(() => {
    const updatedHash = window.location.hash;

    // 既存のハッシュが #search-product 以外の場合は何もしない
    if (updatedHash && updatedHash !== '#search-product') {
      return;
    }

    // ハッシュが消えている場合は #search-product を再付与
    if (!updatedHash) {
      history.replaceState(null, null, window.location.href + '#search-product');
    }
  });

  // 検索結果コンテナを監視 (Shopifyの適切な要素を指定)
  const searchResultsContainer = document.querySelector('.search-results, .search-content'); // 適切なセレクタに変更
  if (searchResultsContainer) {
    observer.observe(searchResultsContainer, { childList: true, subtree: true });
  }
});